// LocalStorage 封装工具
export default {
    /**
     * 获取数据
     * @param {string} key - 键名
     * @returns {any} 解析后的数据，如果不存在返回null
     */
    get(key) {
        try {
            const value = localStorage.getItem(key)
            return value ? JSON.parse(value) : null
        } catch (error) {
            console.error(`Error getting ${key} from localStorage:`, error)
            return null
        }
    },

    /**
     * 保存数据
     * @param {string} key - 键名
     * @param {any} value - 要保存的数据
     */
    set(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value))
        } catch (error) {
            console.error(`Error setting ${key} to localStorage:`, error)
        }
    },

    /**
     * 删除数据
     * @param {string} key - 键名
     */
    remove(key) {
        try {
            localStorage.removeItem(key)
        } catch (error) {
            console.error(`Error removing ${key} from localStorage:`, error)
        }
    },

    /**
     * 清空所有数据
     */
    clear() {
        try {
            localStorage.clear()
        } catch (error) {
            console.error('Error clearing localStorage:', error)
        }
    },

    /**
     * 初始化存储（如果需要）
     */
    init() {
        // 初始化默认数据结构
        if (!this.get('users')) {
            this.set('users', [])
        }
        if (!this.get('products')) {
            this.set('products', [])
        }
        if (!this.get('withdrawals')) {
            this.set('withdrawals', [])
        }
        if (!this.get('notifications')) {
            this.set('notifications', [])
        }
    }
}
